module.exports = __webpack_public_path__ + "assets/img/hover-fields.7f8646ae.png";